import { useCronometreOrder } from '@hooks/useCronometreOrder';
import { Chip } from '@nextui-org/react';
import React from 'react';
import dayjs from 'dayjs';

export const OrdersDetailsItem = ({ orderDetail }: any) => {
  const { getColor, elapsedTime, formatElapsedTime } = useCronometreOrder(orderDetail);
  return (
    <div className="flex flex-col gap-2 items-start w-full justify-start">
      <div className="bg-primary w-full flex justify-center items-center rounded h-6">
        <h5 className="text-small tracking-tight text-default-400 flex flex-col text-white ">
          {orderDetail?.status}
        </h5>
      </div>
      <div className="flex flex-row">
        <h3 className="font-bold leading-none text-default-600 text-lg">
          {orderDetail?.quantity}x {orderDetail?.product?.product?.name}
        </h3>
      </div>
      <div className="flex flex-row gap-2 justify-between items-center">
        <Chip size="sm">{formatElapsedTime(elapsedTime)}</Chip>
        <caption className="text-xs tracking-tight text-default-400 flex flex-row">
          {dayjs(orderDetail?.createdAt).format('DD/MM/YYYY hh:MM a')}
        </caption>
      </div>
    </div>
  );
};
